import { FormGroupName } from '@angular/forms';
import { Component, OnInit, Input } from '@angular/core';

import { FormGroup } from '@angular/forms';

import { FormPackage } from '../../models/df-package';

@Component({
	selector: 'df-text-area',
	templateUrl: './text-area.component.html',
	styleUrls: ['./text-area.component.scss']
})
export class TextAreaComponent implements OnInit {
	@Input() package: FormPackage;
	@Input() form: FormGroup;
	@Input() config: FormGroup;
	constructor() {}

	// eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
	ngOnInit(): void {}
}
